/**
 * Initial state for suggestions reducer
 */
export const initialSuggestionState = {
  currentContextualInputText: '',
  currentField: null,
  currentFieldObject: null,
  currentOperator: null,
  currentPrefixOperator: null,
  editorHasFocus: false,
  suggestionContext: null,
  suggestions: [],
};

/**
 * Reducer for managing suggestions state
 */
export function suggestionsReducer(
  state: typeof initialSuggestionState,
  action: { [key: string]: any; type: string },
) {
  switch (action.type) {
    case 'SET_CONTEXT': {
      return {
        ...state,
        currentContextualInputText:
          action.inputText === undefined ? state.currentContextualInputText : action.inputText,
        currentField: action.field === undefined ? state.currentField : action.field,
        currentOperator: action.operator === undefined ? state.currentOperator : action.operator,
        currentPrefixOperator:
          action.prefixOperator === undefined ? state.currentPrefixOperator : action.prefixOperator,
        suggestionContext: action.context === undefined ? state.suggestionContext : action.context,
      };
    }
    case 'SET_SUGGESTIONS': {
      return {
        ...state,
        suggestions: action.suggestions,
      };
    }
    case 'SET_CURRENT_FIELD_OBJECT': {
      return {
        ...state,
        currentFieldObject: action.fieldObject,
      };
    }
    default: {
      return state;
    }
  }
}
